import calculator from './MagnitudeFitness/calculate.js';

const run = calculator.fitness.bind(calculator);
const getInitialState = () => ({ weight: 0 });

export default {
	name: 'magnitude-fitness',
	run,
	getInitialState
};



// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/GA/lib/fitness/providers/MagnitudeFitness.js